import { select } from '@angular-redux/store';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export interface DialogZoneInfoData {
    mapFile: string;
}

@Component({
    selector: 'rwidget-dialog-zone-info',
    templateUrl: 'dialog-zone-info.component.html',
    styleUrls: ['dialog-zone-info.component.scss']
})
export class DialogZoneInfoComponent implements OnInit {
    @select(['application', 'assetsPath']) assetsPath$;
    translatedTitle: string;

    constructor(
        public dialogRef: MatDialogRef<DialogZoneInfoComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogZoneInfoData,
        @Inject('ENV') public env: any,
        private translateService: TranslateService
    ) {}

    ngOnInit() {
        this.translatedTitle = this.translateService.instant('AREA_INFO_MODAL_TITLE');
    }
}
